import { GoogleLogin } from "@react-oauth/google";
import { handleGoogleSuccess, handleGoogleError } from "../../auth/googleAuth";
import { useAuth } from "../../context/AuthContext";

const GoogleLoginButton = () => {
  const { user, login, logout } = useAuth();

  if (user) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={user.picture}
          alt="profile"
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            border: "2px solid #017E84",
          }}
        />
        <span
          style={{
            fontSize: "0.85rem",
            fontWeight: 600,
            whiteSpace: "nowrap",
            maxWidth: "70px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {user.name}
        </span>
        <button
          onClick={logout}
          style={{
            background: "none",
            border: "1px solid #714B67",
            color: "#714B67",
            cursor: "pointer",
            borderRadius: "4px",
            padding: "2px 8px",
            fontWeight: 600,
            fontSize: "0.75rem",
          }}
        >
          Logout
        </button>
      </div>
    );
  }

  return (
    <div style={{ width: "120px", overflow: "hidden" }}>
      {" "}
      {/* Width reduced for a smaller footprint */}
      <GoogleLogin
        onSuccess={(res) => handleGoogleSuccess(res, login)}
        onError={handleGoogleError}
        useOneTap
        type="standard"
        theme="outline"
        size="medium" // Keeps the height slim
        text="signin" // FIXED: This changes "Sign in with Google" to just "Sign in"
        shape="rectangular"
        width="120" // FIXED: Matching the narrow container width
        logo_alignment="left"
      />
    </div>
  );
};

export default GoogleLoginButton;
